import { createTheme } from '@mui/material'

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#3eb8c4',
      light: '#5ed4e0',
      dark: '#1a6b7a'
    },
    secondary: {
      main: '#c9a227',
      light: '#e0bc4a',
      dark: '#8f7018'
    },
    background: {
      default: '#0a2f3a',
      paper: '#0f3d4a'
    },
    text: {
      primary: '#f0fafc',
      secondary: '#9ec8d0'
    },
    divider: 'rgba(94, 212, 224, 0.12)'
  },
  typography: {
    fontFamily: '"Source Sans 3", "Helvetica Neue", Arial, sans-serif',
    h1: {
      fontFamily: '"Fraunces", Georgia, serif',
      fontWeight: 500,
      letterSpacing: '0.01em'
    },
    h2: {
      fontFamily: '"Fraunces", Georgia, serif',
      fontWeight: 500
    },
    h3: {
      fontFamily: '"Fraunces", Georgia, serif',
      fontWeight: 500
    },
    h4: {
      fontFamily: '"Fraunces", Georgia, serif',
      fontWeight: 500
    },
    h5: {
      fontFamily: '"Fraunces", Georgia, serif',
      fontWeight: 500
    },
    h6: {
      fontFamily: '"Fraunces", Georgia, serif',
      fontWeight: 500
    },
    body1: {
      lineHeight: 1.75
    }
  },
  shape: {
    borderRadius: 10
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          letterSpacing: '0.04em'
        }
      }
    }
  }
})
